import React, { Component } from 'react'
import classnames from 'classnames'
import TSelectForm from "../../common/TSelectForm";

class MenuSelectForm extends TSelectForm {

	render() {
		const { tabIndex, className, items } = this.props
		const { open, selectedIndex } = this.state

		let selectedItem = selectedIndex < 0 ? items[0] : items[selectedIndex]

		return (
			<div ref="root" className={classnames(className, { 'opt_open': open })}>
				<button type="button" className="btn_opt" tabIndex={tabIndex} onClick={this.handleToggleOpen}>
					{ selectedItem.label }
					<span className="ico_blog ico_open"/>
				</button>
				<div className="layer_opt">
					<ul ref="layer" className="list_opt">
					{ items.map((item, idx) =>
						<li key={idx} className={classnames({ "on": idx === selectedIndex })}>
							<label className="lab_btn">
								{item.label}
								<input type="button" className="btn_g" onClick={e => this.handleSelect(item)} />
							</label>
						</li>
					)}
					</ul>
				</div>
			</div>
		)
	}
}

export default MenuSelectForm
